import React, { useMemo } from 'react';
import moment from 'moment';
import DateFormat from 'constants/date_format';
import { SavedElementTypes } from 'constants/savedElements';
import { Icon } from 'ui';

const ElementInfo = ({ element }) => {
  const {
    title,
    description,
    saved_element_type: savedElementType,
    last_updated_at: lastUpdatedAt,
  } = element;

  const lastUpdatedAtFormatted = useMemo(
    () => moment(lastUpdatedAt.date).format(DateFormat.MONTH_DAY_YEAR_SHORT),
    [lastUpdatedAt.date],
  );

  const isLinked = savedElementType === SavedElementTypes.Linked;

  return (
    <>
      <h4 className="ff-ss fw-b f-smooth mb-8">
        {t('element_builder.metadata.name')}
      </h4>
      <p className="fz-18 mb-24 text-wrap">{title}</p>
      <h4 className="ff-ss fw-b f-smooth mb-8">
        {t('element_builder.metadata.is_linked')}
      </h4>
      <p className="mb-24 fz-bigger c-gray-darker">
        {isLinked && <Icon name="link" className="mr-8" />}
        {isLinked
          ? t('element_builder.metadata.is_linked_yes')
          : t('element_builder.metadata.is_linked_no')}
      </p>
      <h4 className="ff-ss fw-b f-smooth mb-8">
        {t('element_builder.metadata.last_edited')}
      </h4>
      <p className="mb-24 fz-bigger c-gray-darker">
        {t('element_builder.metadata.by_user_on_date', {
          user: lastUpdatedAt.user.name,
          date: lastUpdatedAtFormatted,
        })}
      </p>
      {description && (
        <>
          <h4 className="ff-ss fw-b f-smooth mb-8">
            {t('common.description')}
          </h4>
          <p className="fz-bigger c-gray-darker text-wrap">{description}</p>
        </>
      )}
    </>
  );
};

export default ElementInfo;
